<script>
  import { onMount } from "svelte";
  import Header from "../components/Header.svelte";
  import Modal from "../components/Modal.svelte";
  import Notification from "../components/Notification.svelte";
  import ProtectedRoute from "../components/ProtectedRoute.svelte";

  let showNotification = false;
  let message = "";
  let notificationType = "";

  let userData = null;
  let showModal = false;

  let profilePicture = null;
  let selectedFile = null;
  let showDeleteConfirmation = false;

  onMount(async () => {
    userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      await fetchProfilePicture(userData.user._id);
    }
  });

  const handleEditProfile = () => {
    showModal = true; // Display the modal for entering new name and password
  };

  const handleProfileUpdate = () => {
    // Update the userData from localStorage
    userData = JSON.parse(localStorage.getItem("userData"));
    // Close the modal
    showModal = false;
  };

  const fetchProfilePicture = async (userId) => {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/auth/get-pp/${userId}?_=${Date.now()}`
      );
      if (response.ok) {
        const data = await response.json();
        profilePicture = data.profilePicture;
      } else {
        //console.error("Failed to fetch profile picture.");
      }
    } catch (error) {
      //console.error("Error fetching profile picture:", error);
    }
  };

  const handleFileChange = (event) => {
    selectedFile = event.target.files[0];
    if (selectedFile) {
      uploadProfilePicture();
    }
  };

  const uploadProfilePicture = async () => {
    if (!selectedFile) {
      message = "Please select a file to upload.";
      showNotification = true;
      notificationType = "danger";
      setTimeout(() => (showNotification = false), 3000);
      setTimeout(() => {
        message = "";
      }, 3000);
      return;
    }

    const formData = new FormData();
    formData.append("profilePicture", selectedFile);

    try {
      const response = await fetch("https://api.trulens.ae/api/auth/pp", {
        method: "PUT",
        headers: {
          Authorization: userData.token,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        profilePicture = data.profilePicture;
        message = "Profile picture added successfully.";
        showNotification = true;
        notificationType = "success";
        setTimeout(() => (showNotification = false), 3000);
        setTimeout(() => {
          message = "";
        }, 3000);
      } else {
        message = "Failed to upload profile picture.";
        showNotification = true;
        notificationType = "danger";
        setTimeout(() => (showNotification = false), 3000);
        setTimeout(() => {
          message = "";
        }, 3000);
      }
    } catch (error) {
      message = "Error uploading profile picture.";
      showNotification = true;
      notificationType = "danger";
      setTimeout(() => (showNotification = false), 3000);
      setTimeout(() => {
        message = "";
      }, 3000);
    }
  };

  const handleDeleteClick = () => {
    showDeleteConfirmation = true;
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch("https://api.trulens.ae/api/auth/pp", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: userData.token,
        },
      });

      if (response.ok) {
        profilePicture = null;
        message = "Profile picture deleted successfully.";
        showNotification = true;
        notificationType = "success";
        setTimeout(() => (showNotification = false), 3000);
        setTimeout(() => {
          message = "";
        }, 3000);
      } else {
        message = "Failed to upload profile picture.";
        showNotification = true;
        notificationType = "danger";
        setTimeout(() => (showNotification = false), 3000);
        setTimeout(() => {
          message = "";
        }, 3000);
      }
    } catch (error) {
      message = "Error deleting profile picture.";
      showNotification = true;
      notificationType = "danger";
      setTimeout(() => (showNotification = false), 3000);
      setTimeout(() => {
        message = "";
      }, 3000);
    } finally {
      showDeleteConfirmation = false;
    }
  };

  const cancelDelete = () => {
    showDeleteConfirmation = false;
  };

  let subscriberCount = 0;
  let subscriptionCount = 0;
  // Fetch Subscriber Count
  const fetchSubscriberCount = async () => {
    if (userData) {
      try {
        const response = await fetch(
          `https://api.trulens.ae/api/subscribe/count/${userData.user._id}?_=${Date.now()}`
        );
        if (response.ok) {
          const data = await response.json();
          subscriberCount = data.subscriberCount; // The API returns { subscriberCount: number }
        } else {
          console.error("Failed to fetch subscriber count");
        }
      } catch (error) {
        console.error("Error fetching subscriber count:", error);
      }
    }
  };

  // Fetch Subscription Count
  const fetchSubscriptionCount = async () => {
    if (userData) {
      try {
        const response = await fetch(
          `https://api.trulens.ae/api/subscribe/my-subscriptions/count?_=${Date.now()}`,
          {
            method: "GET",
            headers: {
              Authorization: userData.token,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          subscriptionCount = data.subscriptionCount; // The API returns { subscriptionCount: number }
        } else {
          console.error("Failed to fetch subscription count");
        }
      } catch (error) {
        console.error("Error fetching subscription count:", error);
      }
    }
  };

  onMount(() => {
    fetchSubscriberCount();
    fetchSubscriptionCount();
  });

  function redirectToSubscriptions() {
    window.location.href = "#/subscriptions";
  }

  function redirectToSubscribers() {
    window.location.href = "#/subscribers";
  }
</script>

<!-- <link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css"
  integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N"
  crossorigin="anonymous"
/> -->
<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
/>
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
/>

<ProtectedRoute>
  <div class="content">
    <Notification {message} show={showNotification} type={notificationType} />
    <Header />

    <div class="title">
      <span class="title-span">My Profile</span>
    </div>

    <div class="profile-card">
      {#if userData}
        <div class="profile-info">
          <!-- svelte-ignore a11y-img-redundant-alt -->
          {#if profilePicture}
            <!-- svelte-ignore a11y-img-redundant-alt -->
            <img
              src={profilePicture}
              alt="Profile Picture"
              class="profile-picture"
            />
          {:else}
            <img
              src="/profile.png"
              alt="Profile Picture"
              class="profile-picture"
            />
          {/if}

          <div class="icon-actions">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <i
              class="material-icons delete-icon {profilePicture
                ? ''
                : 'disabled'}"
              title="Delete"
              on:click={handleDeleteClick}
              style={profilePicture ? "" : "pointer-events: none;"}>delete</i
            >
            <!-- <i class="material-icons edit-icon" title="Edit">upload</i> -->
            <label
              for="upload-profile-picture"
              class="material-icons edit-icon"
              title="Upload"
            >
              upload
            </label>
            <input
              id="upload-profile-picture"
              type="file"
              accept="image/*"
              on:change={handleFileChange}
              style="display: none;"
            />
          </div>

          <!-- Subscriptions and Subscribers Section -->
          <div class="subscriptions-info">
            <div class="subscriptions-label" on:click={redirectToSubscriptions}>
              <strong>Subscriptions:</strong>
              <span>{subscriptionCount}</span>
            </div>
            <div class="subscribers-label" on:click={redirectToSubscribers}>
              <strong>Subscribers:</strong>
              <span>{subscriberCount}</span>
            </div>
          </div>

          <div class="input-group">
            <div class="input-icon">
              <i class="fas fa-envelope"></i>
            </div>
            <input
              type="text"
              value={userData.user.email}
              disabled
              style="color: black;"
              placeholder="Email"
            />
          </div>
          <div class="input-group">
            <div class="input-icon">
              <i class="fas fa-user"></i>
            </div>
            <input
              type="text"
              value={userData.user.name}
              disabled
              style="color: black;"
              placeholder="Username"
            />
          </div>
          <br />
          <button on:click={handleEditProfile}>Edit Profile</button>
        </div>
      {:else}
        <p>Loading...</p>
      {/if}
    </div>

    <Modal bind:isOpen={showModal} onUpdate={handleProfileUpdate} />

    {#if showDeleteConfirmation}
      <div class="overlay"></div>
      <div class="confirmation-modal">
        <p>Are you sure you want to delete your profile picture?</p>
        <div class="button-container">
          <button on:click={confirmDelete}>Yes</button>
          <button on:click={cancelDelete}>No</button>
        </div>
      </div>
    {/if}
  </div>
</ProtectedRoute>

<style>
  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
    /* background: linear-gradient(to bottom, #FF3C82 45%, #1e92ff 55%); */
    /* background: linear-gradient(130deg, #cdb4db, #ffffff);
      box-shadow:
        inset -20px 0 50px #cdb4db,
        inset 20px 0 50px #cdb4db; */
  }

  .title-span {
    margin-top: 5px;
    /* border: 2px solid #000000; */
    border-radius: 25%;
    /* margin: 0 15px; */
    padding: 5px;
    font-size: 1.2rem;
    color: #000000;
    /* text-decoration: underline; */
    /* cursor: pointer; */
    font-size: 1.4rem;
    font-weight: bold;
  }

  .profile-picture {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 15px;
  }

  .icon-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 10px;
  }

  .icon-actions .material-icons {
    font-size: 24px;
    cursor: pointer;
    transition: color 0.3s ease;
  }

  .icon-actions .delete-icon {
    color: red;
  }

  .icon-actions .delete-icon.disabled {
    color: red;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-actions .edit-icon {
    color: #41a4ff;
  }

  #upload-profile-picture {
    display: none;
  }

  #upload-btn {
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #41a4ff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  #upload-btn:hover {
    background-color: #1e92ff;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .confirmation-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    z-index: 1000;
  }

  .confirmation-modal p {
    margin-bottom: 20px;
    font-size: 16px;
  }

  .confirmation-modal button {
    margin: 0 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .confirmation-modal button:first-child {
    background-color: red;
    color: white;
  }

  .confirmation-modal button:last-child {
    background-color: gray;
    color: white;
  }

  .button-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 20px;
  }

  .profile-card {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin: 20px auto;
    max-width: 400px;
  }

  button {
    padding: 10px 20px;
    margin: 0 10px;
    background-color: #ff3c82;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .input-group {
    position: relative;
    margin-bottom: 15px;
  }

  .input-icon {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: gray;
    pointer-events: none; /* Prevents the icon from interfering with input */
  }

  input[type="text"] {
    padding-left: 30px; /* Space for the icon */
    height: 35px;
    border-radius: 5px;
    border: 1px solid #ccc;
    width: 100%;
  }

  .input-group input[type="text"],
  .input-group input[type="password"] {
    width: calc(100% - 10px);
    padding-left: 40px;
    border-radius: 5px;
    margin: 5px 0;
    border: 1px solid #ffafcc;
    box-sizing: border-box;
  }

  button:hover {
    background-color: #b683d4;
  }

  .profile-info {
    text-align: center;
  }

  .profile-info p {
    margin-bottom: 10px;
  }

  .subscriptions-info {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 16px;
    font-weight: bold;
  }

  .subscriptions-label,
  .subscribers-label {
    flex: 1;
    text-align: center;
    cursor: pointer;
    border-radius: 50px;
  }

  .subscriptions-label:hover,
  .subscribers-label:hover {
    background-color: #ccc;
  }

  .subscriptions-label span,
  .subscribers-label span {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    .title {
      padding: 10px 20px;
    }

    .title-span {
      font-size: 1.2rem;
    }

    .profile-card {
      margin: 20px;
    }

    .subscriptions-info {
      display: flex;
      justify-content: space-between;
      margin: 5px 0;
      font-size: 12px;
      font-weight: bold;
    }

    .subscriptions-label,
    .subscribers-label {
      flex: 1;
      text-align: center;
    }
  }

  @media screen and (min-width: 768px) {
    .title {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: 850px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 850px) and (min-height: 1280px) {
    .title {
      margin-top: 55px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 1024px) and (min-height: 1300px) {
    .title {
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 1440px) {
    .title {
      margin-top: 20px;
    }
  }
</style>
